import { createSlice } from '@reduxjs/toolkit'



const initialState = {
  client: {
    prospective: false,
    clientId: null
  },
  title: '',
  engagementType: null,
  addressedToEmail: [],
  proposalOption: '',
  proposalType: '',
  clientExistingProjectBrief: {
    briefText: '',
    documents: []
  },
  createdProjectBrief: {
    background: null,
    objective: null,
    studyType: null, //enum
    frequency: {
      option: "",
      trackerOptions: null
    },  // enum
    loi: "",
    timelines: {
      number: 0,
      timelineType: null //enum
    },
    complexity: "",
    numberOfSurveyGuides:0
  },
  services: {},
  serviceSpecification: null,
  approximateAmount: 0,
  requestCode: null,
  connectWithSPoc: {
    description: "",
    meetingTimings: "",
    attendees: []
  }
}

export const sliceName = 'rfqMarketResearchSlice'
export const rfqMarketResearchSlice = createSlice({
  name: sliceName,
  initialState,
  reducers: {
    setInitialData: (state, action) => {
      state = action.payload
      return state
    },
    requestForProposal: (state, action) => {
      state.title = action.payload.title
      state.addressedToEmail = action.payload.addressedToEmail
      state.proposalOption = action.payload.proposalOption
      state.engagementType = action.payload.engagementType
      state.clientExistingProjectBrief = action.payload.clientExistingProjectBrief
    },
    projectOverview: (state, action) => {
      state.createdProjectBrief = action.payload.createdProjectBrief
      state.services = action.payload.services
    },
    serviceSpecification: (state, action) => {
      state.serviceSpecification = action.payload
    },
    handleServiceDetails: (state, action) => {
      state.services = action.payload
    },
    handleServices: (state, action) => {
      return { ...state, services: { ...state.services, [action.payload.serviceId]: { ...state.services.dataProcessing, [action.payload.serviceName]: action.payload.value } } };
    },
    handleEngagementType: (state, action) => {
      const engagementType = action.payload;
      return { ...state, engagementType };
    },
    changeApplicable: (state, action) => {
      state.services[action.payload.id].applicable = false
    },
    setApproximateAmount: (state, action) => {
      state.approximateAmount = action.payload
    },

    updateMeetingData: (state, action) => {
      const { description, meetingTimings, attendees } = action.payload
      state.connectWithSPoc = {
        description, meetingTimings, attendees
      }
    },
    resetRFQMarketResearch:()=>{
      return initialState;
    }
  },
})

export const { requestForProposal,resetRFQMarketResearch, handleEngagementType, updateMeetingData, setInitialData, projectOverview, serviceSpecification, handleServiceDetails, changeApplicable, setApproximateAmount, handleServices } = rfqMarketResearchSlice.actions
export const selectRfqMarketingResearchState = (state) => state[sliceName]
export const selectRfqMarketingResearchServices = (state) => state[sliceName].services
export const selectApproximateCost = (state) => state[sliceName].approximateAmount
export const selectAddressedToEmail = (state) => state[sliceName].addressedToEmail
export const selectRequestCode = (state) => state[sliceName].requestCode
export const selectProposalOption = (state) => state[sliceName].proposalOption
export const selectEngagementType = (state) => state[sliceName].engagementType

export default rfqMarketResearchSlice.reducer